import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getalllandcmsdata } from "../../Hooks/useUserHook";
import { useState } from "react";
import { useEffect } from "react";

function Testimonials() {
  const settings = {
    dots: false,
    // infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [cmsdata, setCmsData] = useState([])


  useEffect(() => {
    async function fetchdata() {
      const res = await getalllandcmsdata();
      console.log("res cmsdata", res)
      if (res?.data?.type == "success") {
        setCmsData(res?.data?.data)
      }
    }
    fetchdata();
  }, [])



  const cmsFilter = (data) => {
    try {
      let filterdata = cmsdata?.find(
        (el) => el.Identifier == data && el?.status == "active"
      );
      console.log("filterdata_filterdata", filterdata, filterdata?.updatedAt);
      return filterdata;
    } catch (e) {
      console.log("cmsFilter_err", e);
    }
  };


  return (
    <>
      {cmsdata && cmsdata?.length > 0?<div className="testimonials mb-5">
      <div className="container container_custom">
        <div className="header_sec">
        {/* <h3>Testimonials</h3> */}
          <h3>{cmsFilter("land_banner05")?.Title}</h3>
          {/* <p>Hear what our customers have to say about FlutterPads</p> */}
          <p>{cmsFilter("land_banner05")?.Content}</p>
        </div>
        <div className="carousal_sec mt-4 mt-sm-4 mt-md-5">
          <Slider {...settings} className="sections">


              {cmsFilter("land_banner05")?.ContentArray && cmsFilter("land_banner05")?.ContentArray?.length > 0 && cmsFilter("land_banner05")?.ContentArray?.map((val, item) => <div className="slider_custom_item">
                <p className="mb-0">
                  {val?.Content}
                </p>
                <div className="mt-4 mt-md-5">
                  <h4>{val?.Title}</h4>
                  <p>{val?.Heading}</p>
                </div>
              </div>)}




            {/* <div className="slider_custom_item">
              <p className="mb-0">
                My friends and I stayed in both apartments on top of this
                triplex for six weeks and had a wonderful time! The FlutterPads
                guys are extremely responsive and helpful. Anytime we had a
                problem, they would have someone at the apartment within hours.
                The neighbors are kind, quiet, and courteous. A short walk from
                Hollywood Blvd., restaurants and convenience stores are close
                by, and above all, the surrounding area was safe at all hours.
                Either apartment is perfect for any group of 3- 4 looking for a
                comfortable short/long stay!
              </p>
              <div className="mt-4 mt-md-5">
                <h4>David Y.</h4>
                <p>Stage Actor from Boston</p>
              </div>
            </div>
            <div className="slider_custom_item">
              <p className="mb-0">
                My stay was truly wonderful! The warm welcome by FluterPads and
                their team really set the tone for an awesome 3 month
                experience. The cottage is a real gem - flawlessly clean and
                well-equipped with all I needed, including parking! The location
                struck a perfect balance, letting me explore LA's vibrant
                neighbourhoods and enjoy a peaceful retreat. The hosts went
                above and beyond, ensuring my comfort and sharing excellent
                local recommendations. I can't praise this FlutterPads enough
                for the delightful experience. For a memorable and comfortable
                stay in LA, this cottage is a must-book. I'm eager to return and
                relive the wonderful memories.
              </p>
              <div className="mt-4 mt-sm-4 mt-md-5 ">
                <h4>Srabion H.</h4>
                <p>Psychotherapist from London, UK</p>
              </div>
            </div>
            <div className="slider_custom_item">
              <p className="mb-0">
                FlutterPads’ space is a beautifully centrally located home
                nestled within the safe haven of Los Feliz. The location is
                perfect, minutes from every major landmark. A peaceful, clean,
                and vibrant neighbourhood with more restaurants than anyone
                could need. I would highly recommend this rental. The space
                itself is clean and bright, with lots of natural light. If
                you’re looking for proximity to Hollywood but the peace and
                quiet when you need it, this is the place for me. The
                FlutterPads staff is super responsive, very helpful, and an
                all-around 10-star host. Thanks for the accommodation, guys!
              </p>
              <div className="mt-4 mt-sm-4 mt-md-5 ">
                <h4>Jareiq K.</h4>
                <p>Music Video Producer from London, UK</p>
              </div>
            </div> */}
          </Slider>
        </div>
      </div>
    </div> : <></>}
    </>
  
  );
}

export default Testimonials;
